import { makeAutoObservable } from 'mobx';

import { GeoFence } from '../types/Plan';

const mapStaticElementsData: MapStaticElements = {
  geoFences: [
    {
      type: 'polygon',
      name: 'No fly zone 1',
      polygon: [
        [-122.44, 37.8],
        [-122.41, 37.8],
        [-122.41, 37.82],
        [-122.44, 37.82],
        [-122.44, 37.8]
      ]
    },
    {
      type: 'polygon',
      name: 'No fly zone 2',
      polygon: [
        [-122.34, 37.8],
        [-122.31, 37.8],
        [-122.31, 37.82],
        [-122.34, 37.82],
        [-122.34, 37.8]
      ]
    },
    {
      type: 'circle',
      name: 'No fly zone 3',
      center: [-122.39, 37.82],
      radius: 1000
    }
  ]
};

export interface MapStaticElements {
  geoFences: GeoFence[];
}

export class MapStaticElementsStore {
  mapStaticElements: MapStaticElements = mapStaticElementsData;

  constructor() {
    makeAutoObservable(this);
  }
}

export const mapStaticElementsStore = new MapStaticElementsStore();
